const riot = require('riot');

riot.tag2('page-report', '<div class="f s-full"> <div class="box-shadow" if="{!app.useragent.isMobile}" ref="sidebar" data-is="module-sidebar"></div> <div class="f fclm s-full p40 overflow-y-scroll s-p12"> <div class="flex-fixed bg-white py18 px24 rounded-4"> <div class="row fbw mb8 s-flex-column s-flex-nowrap"> <div class="f fm scrollbar-none mb16 s-overflow-x-scroll s-p2 s-mb8"> <div class="flex-fixed mr18" data-is="module-project-select" ref="projects" projects="{projects}" current-project="{currentProject}"></div> <div class="flex-fixed" data-is="module-user-select" ref="users" users="{users}" current-user="{currentUser}"></div> <div class="flex-fixed h-full w152 mr18" ref="tags" data-is="atom-filter" type="tag" onchange="{fetchEvents}"></div> <div class="flex-fixed h-full bg-white rounded-4 p8 box-shadow mr18"> <div class="text-label_low fs12 lh15 mb8">日付</div> <div class="f fm cursor-pointer" onclick="{onOpenCalendar}"><i class="icon-calendar text-label_high fs18 mr8"></i> <div class="text-label_high lh15">{startAt.format(\'YYYY.MM.DD\')} - {endAt.format(\'YYYY.MM.DD\')}</div> </div> </div> </div> <div class="f fm ft scrollbar-none s-overflow-x-scroll"> <div class="f h32 rounded-4 border border-separator_opaque mr16"> <div class="f fh w100 border-separator_opaque border-right-not-last fs12 cursor-pointer {item.id === current ? &quot;bg-primary_pale text-primary&quot; : &quot;text-label_high&quot;}" each="{item in tabItems}" onclick="{onChangeTab}">{item.label}</div> </div> <div class="p8 hover-trigger cursor-pointer mrn8 mtn11" if="{!app.useragent.isMobile}" onclick="{onOpenActionSheet}"><i class="icon-download hover-text-label_low transition fs28 text-label_disabled"></i></div> </div> </div> <div class="f fbw s-flex-column"> <div class="f overflow-x-scroll h30 scrollbar-none s-mb8"> <button class="button separator_opaque f fh flex-fixed w88 h29 px0 fw4 mr16" if="{sectionsRecords &amp;&amp; refs.tabs.current === &quot;list&quot;}" onclick="{onToggleViewAll}"><i class="fs16 mr4 icon-{isCloseAll() ? &quot;add&quot; : &quot;minus&quot;}"></i> <div class="fs11">全て{isCloseAll() ? \'開く\' : \'閉じる\'}</div> </button> <div class="f fm"> <label class="f fm flex-fixed fs12 cursor-pointer"> <input class="mr9 checkbox" ref="exclusion" type="checkbox" onchange="{fetchEvents}"> <div class="text-label_high">除外プロジェクトを表示</div> </label> </div> </div> <div class="f fm"> <div class="text-label_high letter-spacing-0_03em lh15 bold fs18">累計：{getTotal()}時間</div> </div> </div> </div> <div class="absolute trbl0 z100 f fh s-full bg-white" if="{isLoading}"> <div class="s40" data-is="atom-indicator"></div> </div> <div class="w-full" ref="tabs" data-is="atom-tabs" tabs="{tabs}"></div> <div class="relative s-full overflow-scroll"> <div class="s-full px16" show="{refs.tabs.current === &quot;graph&quot;}" sections="{sectionsRecords}" data-is="module-graph" ref="graph"></div> <div class="overflow-x-scroll" show="{refs.tabs.current === &quot;list&quot;}"> <div each="{section, index in sectionsRecords}"> <div ref="table" data-is="module-table-accordion" section="{section}" data-index="{index}"></div> </div> </div> </div> <div if="{app.useragent.isMobile}" data-is="module-tabbar"></div> </div> </div> <div class="popup fixed z100 bg-black s32" ref="popup"></div>', 'page-report,[data-is="page-report"]{display:block}', '', function(opts) {
    this.isLoading = false;
    this.current = 'date';
    this.startAt = dayjs().startOf('month');
    this.endAt = dayjs();

    this.tabItems = [
      {id: 'date', label: '日付軸'},
      {id: 'project', label: 'プロジェクト軸'},
      {id: 'month', label: '月軸'},
      {id: 'user', label: 'ユーザー軸'},
    ];

    this.tabs = [
      {id: 'list', label: 'リスト'},
      {id: 'graph', label: 'グラフ'},
    ];

    this.on('mount', () => {

      this.refs.projects.on('select', (project) => {
        this.currentProjectID = project.id;
        this.fetchEvents();
      });

      this.refs.tabs.on('change', (id) => {
        if (id === 'graph') {
          requestAnimationFrame(() => {
            this.refs.graph.renderChart();
          });
        }
        this.update();
      });

      this.refs.users.on('select', (user) => {
        this.currentUserID = user.id;
        this.fetchEvents();
      });
    });

    this.on('changerecord', () => {
      this.fetchEvents();
    });

    this.preload = async ({req, res}) => {
      this.isLoading = true;
      this.update();

      var promises = [
        app.store.collection('users')
          .where('disabled', '==', false)
          .fetch({ relation: true }),
        app.store.collection('projects').fetch({ relation: true }),
      ];

      var [users, projects] = await Promise.all(promises);

      users = app.utils.sortUserName(users);
      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);

      var all_user = { id: 'all', data: { screen_name:'all' }, all: true };
      users.unshift(all_user);

      var all_project = { id: 'all', data: { name:'all' }, all: true };
      projects.unshift(all_project);

      var unselected_project = { id: 'unselect', data: { name:'未設定' }, unselected: true };
      projects.push(unselected_project);

      return {
        users,
        projects,
      };
    };

    this.on('show', async ({req, res}) => {
      this.selectMe();

      if (req.query.q) {
        var query = QuerySearch.parse(req.query.q);
        if (query.options.project_id) {
          this.currentProjectID = query.options.project_id;
        }
        if (query.options.user_id) {
          this.currentUserID = query.options.user_id;
        }
        if (query.options.start_at) {
          this.startAt = dayjs(query.options.start_at);
        }
        if (query.options.end_at) {
          this.endAt = dayjs(query.options.end_at).endOf('date');
        }
        if (query.options.tag) {
          this.refs.tags.setTagValue(query.options.tag);
        }
      }

      this.fetchEvents();
    });

    this.onClickTagFilter = () => {
      alert('タグ絞り込み機能未実装');
    };

    this.onOpenCalendar = () => {
      spat.modal.open('modal-calendar', {
        start_at: this.startAt,
        end_at: this.endAt,
      }).on('submit', ({start_at, end_at}) => {
        this.startAt = start_at;
        this.endAt = dayjs(end_at).endOf('date');
        this.fetchEvents();
      });
    };

    this.fetchEvents = async () => {
      this.isLoading = true;
      this.update();

      var start = this.startAt;
      var end = this.endAt;

      if (end.isAfter()) end = dayjs();

      var where_items = [
        ['start_at', '>=', start.valueOf()],
        ['start_at', '<=', end.valueOf()],
      ];

      var select_user_id = this.currentUserID || this.currentUser.id || 'all';
      this.currentUser = this.users.find(u => u.id === select_user_id);
      this.update();
      this.refs.users.setup();

      if (this.currentUser.id !== 'all') {
        where_items.push(['created_user_ref', '==', this.currentUser.ref]);
      }

      var select_project_id = this.currentProjectID ? this.currentProjectID : 'all';
      this.currentProject = this.projects.find(p => p.id === select_project_id);

      if (this.currentProject.id !== 'all' && this.currentProject.id !== 'unselect') {
        this.currentProject = this.projects.find(p => p.id === select_project_id);
        where_items.push(['project_ref', '==', this.currentProject.ref]);
      }

      else if (select_project_id === 'unselect') {
        where_items.push(['project_ref', '==', null]);
      }
      this.update();
      this.refs.projects.setup();

      if (this.refs.tags.tagValue) {
        where_items.push(['tags', 'array-contains', this.refs.tags.tagValue])
      }

      var ref = app.store.collection('records');
      where_items.forEach(w => {
        ref = ref.where(...w);
      });
      var records = await ref.fetch({ relation: true });

      records = records.filter(item => !item.data.is_recording);

      if (!this.refs.exclusion.checked) {
        records = records.filter(record => record.relation.project && record.relation.project.data && !record.relation.project.data.exclusion);
      }
      this.records = records;

      this.sectionsRecords = this.getSectionedRecords();

      this.update();
      requestAnimationFrame(() => {
        this.isLoading = false;
        this.update();
        if (this.refs.tabs.current === 'graph') {
          this.refs.graph.renderChart();
        }
      });

      var q = `project_id:${select_project_id} user_id:${select_user_id} start_at:${this.startAt.format('YYYYMMDD')} end_at:${this.endAt.format('YYYYMMDD')} tag:${this.refs.tags.tagValue}`;
      var next_url = `${location.pathname}?q=${q}`;
      history.replaceState(null, null, next_url);

    };

    this.onChangeTab = (e) => {
      if (this.current === e.item.item.id) return;

      this.current = e.item.item.id;
      this.sectionsRecords = this.getSectionedRecords();
      requestAnimationFrame(() => {
        if (this.refs.tabs.current === 'graph') {
          this.refs.graph.renderChart();
        }
        this.update();
      });
    };

    this.getSectionedRecords = () => {
      var axis = this.current;
      var groups = null;

      if (axis === 'date') {
        groups = _.groupBy(this.records, (item) => {
          return dayjs(item.data.start_at).format('YYYY.MM.DD(ddd)');
        });
      }
      else if (axis === 'project') {
        groups = _.groupBy(this.records, (item) => {
          if (item.relation.project && item.relation.project.doc.exists) {
            return item.relation.project.data.name;
          }
          return '-';
        });
      }

      else if (axis === 'month') {
        groups = _.groupBy(this.records, (item) => {
          return dayjs(item.data.start_at).format('YYYY/MM');
        });
      }

      else if (axis === 'user') {
        groups = _.groupBy(this.records, (item) => {
          if (item.relation.created_user?.doc.exists) {
            return `${item.relation.created_user?.data.display_name}`;
          }
        });
      }

      var sections = Object.entries(groups).map(([key, value]) => {
        return {
          label: key,
          items: value,
        };
      });

      if (axis === 'date') {
        sections.sort((a, b) => a.label.toLowerCase() < b.label.toLowerCase() ? 1 : -1);
      }
      sections.forEach((section) => {

        var duration = section.items.reduce((a, record) => {
          var diff = +(record.getDuration()/1000/60/60).toLocaleString("en", {maximumFractionDigits: 2})
          return a + diff;
        }, 0);

        section.hours = Number(duration.toLocaleString("en", {maximumFractionDigits: 2}).replace(/,/g,''));
      });

      return sections;
    };

    this.getTotal = () => {
      var sections = this.getSectionedRecords();

      var result = sections.reduce((sum, section) => {
        return sum + section.hours;
      }, 0);

      return result.toLocaleString(undefined, {maximumFractionDigits: 2});
    };

    this.selectMe = () => {
      this.currentUser = app.store.currentUser;
      this.update();
    };

    this.onToggleViewAll = () => {
      var is_close_all = this.isCloseAll();
      var tables = [this.refs.table || []].flat();
      tables.forEach(table => table.isClose = !is_close_all);
    };

    this.isCloseAll = () => {
      var tables = [this.refs.table || []].flat();
      return tables.every(table => table.isClose === true);
    };

    this.exportFile = () => {
      var filename = `${dayjs().format('YYYYMMDD_HHmmss')}_report.tsv`;
      var data = [
        ['date', 'project', 'user', 'title', 'tags', 'duration(h)'],
      ];

      this.records.forEach(record => {
        var project = record.relation.project;

        if (!this.refs.exclusion.checked && project && project.doc.exists && project.data.exclusion) {
          return ;
        }

        var line = [
          dayjs(record.data.start_at).format('YYYY/MM/DD'),
          record.relation?.project?.data?.name || '-',
          record.relation.created_user.data.display_name,
          record.data.title,
          record.data.tags?.toString(),
          (record.getDuration()/1000/60/60).toLocaleString(undefined, {maximumFractionDigits: 2}),
        ];
        data.push(line);
      });
      var value = data.map(d => d.join('\t')).join('\n');

      app.utils.downloadFile(filename, value);
    };

    this.exportListFile = () => {
      var line = [];

      var filename = `${dayjs().format('YYYYMMDD_HHmmss')}${this.currentProject ? '_' + this.currentProject.data.name : ''}_report_list.tsv`;

      var total = 0;

      var unique_users = app.utils.unique(this.records, record => record.relation.created_user.id).map(record => record.relation.created_user);

      var header = [
        '日付',
        ...unique_users.map(u => u.data.display_name),
        '合計(日)',
      ];
      var data = [header];

      var dates = Array.from({length: this.getPeriodDiff() + 1}).map((v, i) => {
        return dayjs(this.startAt).add(i, 'day').endOf('date');
      });

      var date_groups = _.groupBy(this.records, (item) => {
          return dayjs(item.data.start_at).format('YYYY/MM/DD (ddd) ');
      });

      dates.forEach((date) => {
        var key = date.format('YYYY/MM/DD (ddd) ');
        var records = date_groups[key] || [];

        var users_duration = unique_users.map(u => 0);
        records.forEach((record) => {

          let created_user_id = record.relation.created_user.id;

          let project = record.relation.project;

          if (!this.refs.exclusion.checked && project && project.doc.exists && project.data.exclusion) {
            return ;
          }

          var index = unique_users.findIndex(user => user.id === created_user_id);

          let duration = +(record.getDuration()/1000/60/60).toLocaleString(undefined, {maximumFractionDigits: 2})

          users_duration[index] += duration;
        });

        var date_total = users_duration.reduce((sum, num) => {
          return sum + num;
        }, 0).toLocaleString(undefined, {maximumFractionDigits: 2});
        total += +date_total;

        line = [
          key,
          ...users_duration,
          date_total,
        ];
        data.push(line);
      });

      var value = data.map(d => d.join('\t')).join('\n');
      app.utils.downloadFile(filename, value);
    };

    this.getPeriodDiff = () => {
      let from = dayjs(this.startAt);
      let to = dayjs(this.endAt);
      let diff = to.diff(from, 'day');
      return diff;
    };

    this.onOpenActionSheet = (e) => {
      e.preventDefault();
      e.stopPropagation();

      var options = [
        {
          icon: 'report',
          label: '詳細を出力',
          action: 'detail',
        },
        {
          icon: 'menu',
          label: '一覧を出力',
          action: 'list',
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        align: {x:'right'},
        offsetTop: -8,
        position: 'bottom',
        opts: {
          options,
        }
      }).on('select', ({ option }) => {
        if(option.action === 'detail') {
          this.exportFile();
        }
        if(option.action === 'list') {
          this.exportListFile();
        }
        popup.close();
      });
    };
});